import { Injectable } from '@angular/core';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

const STORAGE_KEY = 'wg_browser_id';

@Injectable({ providedIn: 'root' })
export class BrowserIdService {
  private browserId: string | null = null;
  private readyPromise: Promise<string>;

  constructor() {
    this.readyPromise = this.resolve();
  }

  ready(): Promise<string> {
    return this.readyPromise;
  }

  get value(): string {
    return this.browserId ?? this.fallback();
  }

  private async resolve(): Promise<string> {
    try {
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      if (result?.visitorId) {
        this.browserId = result.visitorId;
        this.persist(this.browserId);
        return this.browserId;
      }
    } catch (e) {
      console.warn('FingerprintJS failed, falling back to UUID', e);
    }
    this.browserId = this.fallback();
    return this.browserId;
  }

  private fallback(): string {
    try {
      const cached = localStorage.getItem(STORAGE_KEY);
      if (cached) {
        return cached;
      }
      const generated = this.generateId();
      localStorage.setItem(STORAGE_KEY, generated);
      return generated;
    } catch {
      return this.generateId();
    }
  }

  private persist(id: string): void {
    try {
      localStorage.setItem(STORAGE_KEY, id);
    } catch {
      /* ignore - localStorage blocked */
    }
  }

  private generateId(): string {
    const bytes = new Uint8Array(16);
    crypto.getRandomValues(bytes);
    return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  }
}
